import React, { useState, useEffect, useContext } from "react"
import { navigate } from "gatsby"
import { submitForm } from "../../functions/submit-form"
// import Cookies  from "js-cookie";
import cookieContext from "../../contexts/cookieProvider";
import utmContext from "../../contexts/utmProvider";

const RequestForm = ({hubspotData, theme = 'dark'}) => {
  console.log(hubspotData)
  const { bannerHidden } = React.useContext(cookieContext)
  const { formFieldGroups, guid, portalId } = hubspotData
  const [form, setform] = useState({})
  const [initialFormValues,setInitialFormValues] = useState({})
  const [phone, setPhone] = useState('')
  const { utm } = useContext(utmContext)
  const [error, setError] = useState({})

  const getFields = () => {
    return Object.keys(form).map(key => {
      return {
        name: key,
        value: form[key],
      }
    })
  }
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();

  }
  const insertFormToCookie = (form) =>{
    const now = new Date();
    const time = now.getTime();
    const days = 400;
    const expireTime = time + days*24*60*60*1000;
    now.setTime(expireTime);
    const requiredCookieFields = ["firstname","lastname","email","phone","company","jobtitle","state"];
    let formData = {};
    Object.keys(form).forEach(field=>{
      if ( requiredCookieFields.includes(field) ) {
          formData[field] = form[field];
      }
    })
    const data = getCookie('formData');
    if(data){
      const prevData = JSON.parse(data);
      formData = {
        ...prevData,
        ...formData,
      };
    }
    document.cookie = `formData=${JSON.stringify(formData)};expires=${now}.toUTCSTtring();path=/`;

  }
  const submitFormData = async (e) => {
    e.preventDefault()
    let _error = {}

    formFieldGroups?.forEach(({ fields }) => {
      fields.forEach(field => {
        if (field.required === true) {
          if (form[field.name] === undefined || form[field.name] === "") {
            _error = {
              ..._error,
              [field.name]: `${field.label} is required`,
            }
          }
        }
      })
    })

    setError(_error)

    if (Object.keys(_error).length === 0) {
      let data = await submitForm(guid, getFields(), Date.now(), true)
      if( bannerHidden ){
        insertFormToCookie(form)
      }
      if (data.inlineMessage) {
        console.log(data.inlineMessage)
      } else {
        if (typeof window != "undefined") {
          navigate(data.redirectUri)
          // window.open(data.redirectUri)
          console.log("File has been opened on new tab")
        }
      }
    }
  }
  const getFormatPhoneNumber = (originalPhone) =>{
    if ( !originalPhone ) return '';
    const formatPhone = originalPhone.replace(/[^\d]/g, '');
    const formatPhoneLength = formatPhone.length;
    if (formatPhoneLength){
      if (formatPhoneLength < 4) return formatPhone;
      if (formatPhoneLength < 7) return `(${formatPhone.slice(0, 3)}) ${formatPhone.slice(3)}`; 
      return `(${formatPhone.slice(0, 3)}) ${formatPhone.slice(3, 6)}-${formatPhone.slice(6, 10)}`;
    }
  }
  const handleFieldChange = e => {
    setform({
      ...form,
      [e.target.name]: e.target.name !== 'phone' ? e.target.value : getFormatPhoneNumber(e.target.value),
    })
  }
  function handleChangeInitialFormValues(type = null, value = null) {
    if (!type || !value) return;
    initialFormValues[type] = type !== 'phone' ? value : getFormatPhoneNumber(value);
    if (type === 'phone') {
      setPhone(getFormatPhoneNumber(value))
    }
    setInitialFormValues({...initialFormValues})
  }

  useEffect(() => {
    let formData = getCookie('formData')
    if (formData) {
      formData = JSON.parse(formData); 
    } else {
      formData = {};
    }
    formFieldGroups?.map(({ fields }) =>
    fields.forEach(field => {
        if(utm){
          const urlParams = Object.keys(utm)
          urlParams.forEach(utmkey => {
            if( field.name === utmkey){
              handleChangeInitialFormValues(field.name, utm[utmkey])
            }
          })
          if (!urlParams.includes(field.name)) {
            handleChangeInitialFormValues(field.name, formData[field.name] || "")
          }
        }else{
          handleChangeInitialFormValues(field.name, formData[field.name] || "")
        }
      })
    )
    setform(initialFormValues)   
  }, [formFieldGroups, utm])

  return (
    <div className={`${theme==='dark' ? 'bg-ProjectBlack' : 'bg-black'} rounded-sm w-full mx-auto px-5 md:px-[30px] pt-[38px] pb-[21px]`}>
      <form onSubmit={submitFormData} className = {`hs-form-${guid}`} data-form-id={`${guid}`} data-portal-id={`${portalId}`}>
        {formFieldGroups?.map(({ fields }, index) => {
          return (
            <div className={`w-full ${index === 0  ?  "" : " pt-2.5"} ${fields[0].hidden? " hidden": ""}`} key= {`mainpage-hubspot-${index}`}>
              <div
                className={
                  fields.length > 1
                    ? "flex items-center mx-auto flex-col md:flex-row"
                    : ""
                }
              >
                {fields.map(
                  ({
                    label,
                    placeholder,
                    fieldType,
                    required,
                    name,
                    options,
                    hidden,
                    defaultValue
                  }) => (
                    <label
                      htmlFor={name}
                      className={`block ${theme==='dark' ? 'text-black' : 'text-white'} Figtree-Bold font-bold uppercase text-xs mb-2 tracking-widest leading-3 ${
                        fields.length > 1 && "w-full md:first:mr-5"
                      }`}
                      key={name}
                    >
                      {`${label}${required ? "*" : ""}`}
                      {fieldType === "text" && (
                        <>
                          <input
                            type={hidden? "hidden": fieldType}
                            name={name}
                            value={form[name]}
                            onChange={handleFieldChange}
                            placeholder={placeholder}
                            className={`cursor-text block border-2 border-transparent focus:border-2 focus:border-ProjectBlue ${theme==='dark' ? 'bg-[#0000000D]' : 'bg-white'} w-full h-[44px] px-[10px] pt-[12px] pb-[8px] text-base text-black font-normal mt-[10px] font-workSans rounded-sm ${
                              Object.keys(error).find(key => key === name) &&
                              error[
                                Object.keys(error).find(key => key === name)
                              ] !== "" &&
                              "bg-[#FFE8F0]"
                            }`}
                            id={name}
                            onBlur={() => {
                              if (label.toLowerCase() === "work email") {
                                if (
                                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                    form[name]
                                  ) &&
                                  form[name] !== ""
                                ) {
                                  setError({
                                    ...error,
                                    [name]: "Please enter a valid email",
                                  })
                                } else if (form[name] === "") {
                                  setError({
                                    ...error,
                                    [name]: `${label} is required`,
                                  })
                                } else {
                                  setError({
                                    ...error,
                                    [name]: "",
                                  })
                                }
                              }
                            }}
                          />
                          {Object.keys(error).find(key => key === name) && (
                            <p className="font-workSans font-normal text-[13px] text-[#FF0057] mt-[7px] cursor-text normal-case">
                              {error[name]}
                            </p>
                          )}
                        </>
                      )}
                      {fieldType === "phonenumber" && (
                        <>
                          <input
                            type={hidden? "hidden": fieldType}
                            name={name}
                            value={form[name]}
                            onChange={handleFieldChange}
                            placeholder={placeholder}
                            className={`cursor-text block border-2 border-transparent focus:border-2 focus:border-ProjectBlue ${theme==='dark' ? 'bg-[#0000000D]' : 'bg-white'} w-full h-[44px] px-[15px] pt-[12px] pb-[8px] text-base text-black font-normal mt-[10px] font-workSans rounded-sm ${
                              Object.keys(error).find(key => key === name) &&
                              error[
                                Object.keys(error).find(key => key === name)
                              ] !== "" &&
                              "bg-[#FFE8F0]"
                            }`}
                            id={name}
                          />
                          {Object.keys(error).find(key => key === name) && (
                            <p className="font-workSans font-normal text-[13px] text-[#FF0057] mt-[7px] cursor-text normal-case">
                              {error[name]}
                            </p>
                          )}
                        </>
                      )}
                      {fieldType === "number" && (
                        <>
                          <input
                            type={hidden? "hidden": fieldType}
                            name={name}
                            value={form[name]}
                            onChange={handleFieldChange}
                            placeholder={placeholder}
                            className={`cursor-text block border-2 border-transparent focus:border-2 focus:border-ProjectBlue ${theme==='dark' ? 'bg-[#0000000D]' : 'bg-white'} w-full h-[44px] px-[15px] pt-[12px] pb-[8px] text-base text-black font-normal mt-[10px] font-workSans rounded-sm ${
                              Object.keys(error).find(key => key === name) &&
                              error[
                                Object.keys(error).find(key => key === name)
                              ] !== "" &&
                              "bg-[#FFE8F0]"
                            }`}
                            id={name}
                          />
                          {Object.keys(error).find(key => key === name) && (
                            <p className="font-workSans font-normal text-[13px] text-[#FF0057] mt-[7px] cursor-text normal-case">
                              {error[name]}
                            </p>
                          )}
                        </>
                      )}
                      {fieldType === "textarea" && (
                        <>
                          <textarea
                            placeholder={placeholder}
                            className={`cursor-text block border-2 border-transparent  focus:border-2 focus:border-ProjectBlue bg-[#0000000D] w-full h-[120px] px-[15px] pt-[12px] pb-[8px] text-base text-black font-normal mt-[10px] font-workSans resize-y rounded-sm py-2 ${
                              Object.keys(error).find(key => key === name) &&
                              "bg-[#FFE8F0]"
                            }`}
                            type={fieldType}
                            name={name}
                            required={required}
                            onChange={handleFieldChange}
                            id={name}
                          ></textarea>
                          {Object.keys(error).find(key => key === name) && (
                            <p className="font-workSans font-normal text-[13px] text-[#FF0057] mt-[7px] cursor-text">
                              {error[name]}
                            </p>
                          )}
                        </>
                      )}
                      {fieldType === "select" && (
                        /* eslint-disable-next-line */
                        <>
                          <select
                            placeholder={placeholder}
                            className={`cursor-text block focus:border-2 focus:border-ProjectBlue bg-[#0000000D] w-full h-[44px] px-[15px] pt-[12px] pb-[8px] text-base text-black font-normal mt-[10px] font-workSans rounded-sm ${
                              Object.keys(error).find(key => key === name) &&
                              "bg-[#FFE8F0]"
                            }`}
                            name={name}
                            required={required}
                            onChange={handleFieldChange}
                          >
                            {options.map(option => (
                              <option value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          {Object.keys(error).find(key => key === name) && (
                            <p className="font-workSans font-normal text-[13px] text-[#FF0057] mt-[7px] cursor-text">
                              {error[name]}
                            </p>
                          )}
                        </>
                      )}
                    </label>
                  )
                )}
              </div>
            </div>
          )
        })}
        <div className="w-full mt-[30px]">
          <button
            className="bg-ProjectBlue border-ProjectBlue h-[50px] text-ProjectBlack hover:text-ProjectBlue hover:bg-transparent transition duration-300 ease-in-out font-normal text-center uppercase border-2 rounded-sm Saira-Bold w-full text-sm"
            type="submit"
          >
            Submit
          </button>
        </div>
        <div className="w-full mt-5">
          <p className={`${theme==='dark' ? 'text-TextLegal' : 'text-white'} text-[11px] font-workSans leading-4 font-normal  hover:cursor-pointer`}>
            We're committed to your privacy. Atlas One uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, check out our  
              <a className="text-blue" href="/privacy"> Privacy Policy</a>
            </p>
        </div>
      </form>
    </div>
  )
}

export default RequestForm
